const T = require("react").PropTypes;
const moment = require("moment");

const AuditTypes = require("~/config.js").AuditTypes;
const defaultStatusName = "Not started";

function getStatusName(audit) {
    if (audit.CompletedBy) {
        return "Complete";
    }

    if (audit.Created) {
        return "In progress";
    }

    return defaultStatusName;
}

const MetaAudit = {
    /* For now, we only include props that we're actually using */
    PropType: T.shape({
        AuditPeriod: T.string.isRequired,
        AuditType: T.string.isRequired,
        PKID: T.string,
        FacilityID: T.number.isRequired,
        FacilityNumber: T.string.isRequired,
        Score: T.number,
        MaxScore: T.number,
        CreatedBy: T.string,
        Created: T.object,
        CompletedBy: T.string,
        Completed: T.object,
        IsLegacy: T.bool,
        MetaPages: T.arrayOf( T.shape({
            FriendlyName: T.string.isRequired,
            InternalStepNumber: T.number.isRequired,
            MaxScore: T.number.isRequired,
            PKID: T.string.isRequired,
            Score: T.number.isRequired,
            MetaSection: T.arrayOf(T.shape({
                DisplayOrder: T.number.isRequired,
                TitleHTML: T.string.isRequired,
                MaxScore: T.number.isRequired,
                PKID: T.string.isRequired,
                Score: T.number.isRequired,
            })).isRequired
        })),
        // Additional properties
        Status: T.string,
        FriendlyTypeName: T.string
    }),
    HasValidType(audit, i) {
        const validTypes = Object.keys(AuditTypes);

        const isValid = validTypes.indexOf(audit.AuditType) > -1;

        return isValid;
    },
    FromServerData(audit) {
        const statusName = getStatusName(audit);
        const friendlyTypeName = AuditTypes[audit.AuditType].FriendlyName;

        const completedAsDate = audit.Completed
            ? moment(audit.Completed).toDate()
            : null;

        const result = Object.assign({}, audit, {
            Status: statusName,
            FriendlyTypeName: friendlyTypeName,
            Created: moment(audit.Created).toDate(),
            Completed: completedAsDate
        });

        return result;
    },
    AsAuditPeriodPlaceholder(auditPeriod, auditType, facilityID, facilityNumber) {
        const friendlyTypeName = AuditTypes[auditType].FriendlyName;

        return {
            AuditPeriod: auditPeriod,
            AuditType: auditType,
            FacilityID: facilityID,
            FacilityNumber: facilityNumber,
            Status: defaultStatusName,
            FriendlyTypeName: friendlyTypeName,
            IsLegacy: false
        }
    },
    /**
     * If any required audit type/audit period permutations are missing from
     * the specified list, adds them as placeholder audits.
     * 
     * See AsAuditPeriodPlaceholder for what a placeholder looks like.
     */
    ListWithPeriodPlaceholders(list, facilityID, facilityNumber) {
        Object.keys(AuditTypes).forEach(auditTypeName => {
            const now = moment();

            const period = `Q${now.quarter()} ${now.year()}`;

            const found = list.find((a) => {
                return a.AuditPeriod === period && a.AuditType === auditTypeName;
            })

            if (!found) {
                const placeholder = MetaAudit.AsAuditPeriodPlaceholder(
                    period, auditTypeName, facilityID, facilityNumber);

                list.push(placeholder);
            }
        });

        return list;
    }
};

module.exports = MetaAudit;


// WEBPACK FOOTER //
// ./src/types/MetaAudit.js